import { render, staticRenderFns } from "./EmojisTool.vue?vue&type=template&id=f900e8b0"
import script from "./EmojisTool.vue?vue&type=script&lang=js"
export * from "./EmojisTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports